export default __webpack_public_path__ + "static/media/sad.d05c7a4e.svg";